<template>
  <div class="home container">
    <CustomerService></CustomerService>
    <Carousel height="607.5px" theme="banner" :list="banner" name="home" />
    <div class="main">
      <div class="search">
        <el-form :model="form" ref="form" class="search-form">
          <el-form-item prop="destination" class="destination">
            <div class="icon-svg">
              <svg width="20px" height="30px" viewBox="0 0 20 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="页面-1" stroke="none" stroke-width="1" fill-rule="evenodd">
                  <g id="icon-location">
                    <path
                      d="M10,5.61 C11.3,5.61 12.47,6.17 13.33,7.07 C14.18,7.97 14.71,9.22 14.71,10.6 C14.71,11.98 14.18,13.22 13.33,14.13 C12.48,15.04 11.3,15.59 10,15.59 C8.7,15.59 7.53,15.03 6.67,14.13 C5.82,13.23 5.29,11.98 5.29,10.6 C5.29,9.22 5.82,7.98 6.67,7.07 C7.52,6.17 8.7,5.61 10,5.61 M10,0 C12.76,0 15.26,1.19 17.07,3.11 C18.88,5.03 20,7.68 20,10.61 C20,16.93 16.2,22.47 12.72,27.56 C12.39,28.04 12.08,28.5 11.67,29.1 C11.47,29.39 11.23,29.61 10.94,29.77 C10.65,29.93 10.34,30.01 10.01,30.01 C9.68,30.01 9.36,29.93 9.07,29.77 C8.78,29.61 8.54,29.39 8.34,29.1 C7.93,28.5 7.62,28.04 7.29,27.56 C3.8,22.47 0,16.92 0,10.6 C0,7.68 1.12,5.02 2.93,3.11 C4.74,1.19 7.24,0 10,0 Z"
                      id="d"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            <el-input v-model="form.destination" :placeholder="ts('Destination')['Destination']"></el-input>
          </el-form-item>
          <div class="search-col2">
            <el-form-item prop="date" class="date-picker">
              <div class="icon-svg checkin">
                <svg width="31px" height="30px" viewBox="0 0 31 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="页面-1" stroke="none" stroke-width="1" fill-rule="evenodd">
                    <g id="icon-check-in" transform="translate(0.990000, 0.000000)" fill-rule="nonzero">
                      <path
                        d="M27.64,3.13 L26.57,3.13 L26.57,1.59 C26.57,0.71 25.86,0 24.98,0 L23.78,0 C22.9,0 22.19,0.71 22.19,1.59 L22.19,3.13 L7.51,3.13 L7.51,1.59 C7.51,0.71 6.8,0 5.92,0 L4.72,0 C3.84,0 3.13,0.71 3.13,1.59 L3.13,3.13 L2.37,3.13 C1.06,3.13 0,4.19 0,5.5 L0,27.63 C0,28.94 1.06,30 2.37,30 L27.64,30 C28.95,30 30.01,28.94 30.01,27.63 L30.01,5.49 C30.01,4.18 28.95,3.12 27.64,3.12 L27.64,3.13 Z M20.48,19.81 C20.48,19.81 20.47,19.84 20.46,19.86 C20.46,19.88 20.45,19.9 20.44,19.92 C20.44,19.94 20.42,19.96 20.41,19.98 C20.41,20 20.39,20.01 20.38,20.03 C20.36,20.06 20.33,20.1 20.3,20.13 L15.44,24.99 C15.2,25.23 14.8,25.23 14.56,24.99 C14.32,24.75 14.32,24.35 14.56,24.11 L18.35,20.32 L10.15,20.32 C9.98,20.32 9.82,20.25 9.71,20.14 C9.6,20.03 9.53,19.87 9.53,19.7 C9.53,19.35 9.81,19.07 10.15,19.08 L18.36,19.08 L14.57,15.29 C14.33,15.05 14.33,14.65 14.57,14.41 C14.81,14.17 15.21,14.17 15.45,14.41 L20.31,19.27 C20.31,19.27 20.36,19.33 20.39,19.37 C20.4,19.39 20.41,19.4 20.42,19.42 C20.43,19.44 20.44,19.46 20.45,19.48 C20.45,19.5 20.46,19.52 20.47,19.54 C20.47,19.56 20.48,19.58 20.49,19.59 C20.51,19.67 20.51,19.75 20.49,19.83 L20.48,19.81 Z M28.76,9.38 L1.26,9.38 L1.26,5.5 C1.26,4.88 1.76,4.38 2.38,4.38 L3.14,4.38 L3.14,5.92 C3.14,6.8 3.85,7.51 4.73,7.51 L5.93,7.51 C6.81,7.51 7.52,6.8 7.52,5.92 L7.52,4.38 L22.21,4.38 L22.21,5.92 C22.21,6.8 22.92,7.51 23.8,7.51 L25,7.51 C25.88,7.51 26.59,6.8 26.59,5.92 L26.59,4.38 L27.66,4.38 C28.28,4.38 28.78,4.88 28.78,5.5 L28.78,9.38 L28.76,9.38 Z"
                        id="d"
                      ></path>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="icon-svg checkout">
                <svg width="31px" height="30px" viewBox="0 0 31 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="页面-1" stroke="none" stroke-width="1" fill-rule="evenodd">
                    <g id="icon-check-out" transform="translate(0.990000, 0.000000)" fill-rule="nonzero">
                      <path
                        d="M27.64,3.07 L26.57,3.07 L26.57,1.56 C26.57,0.7 25.86,0 24.98,0 L23.78,0 C22.9,0 22.19,0.7 22.19,1.56 L22.19,3.07 L7.51,3.07 L7.51,1.56 C7.51,0.7 6.8,0 5.92,0 L4.72,0 C3.84,0 3.13,0.7 3.13,1.56 L3.13,3.07 L2.37,3.07 C1.06,3.07 0,4.12 0,5.4 L0,27.19 C0,28.48 1.06,29.52 2.37,29.52 L27.64,29.52 C28.95,29.52 30.01,28.47 30.01,27.19 L30.01,5.41 C30.01,4.12 28.95,3.08 27.64,3.08 L27.64,3.07 Z M19.87,19.98 L11.66,19.98 L15.45,23.71 C15.69,23.95 15.69,24.34 15.45,24.58 C15.21,24.82 14.81,24.82 14.57,24.58 L9.71,19.8 C9.71,19.8 9.66,19.74 9.63,19.71 C9.62,19.69 9.61,19.68 9.6,19.66 C9.59,19.64 9.58,19.62 9.57,19.6 C9.57,19.58 9.56,19.56 9.55,19.54 C9.55,19.52 9.54,19.51 9.53,19.49 C9.51,19.41 9.51,19.33 9.53,19.25 C9.53,19.23 9.54,19.22 9.55,19.2 C9.55,19.18 9.56,19.16 9.57,19.14 C9.57,19.12 9.59,19.1 9.6,19.08 C9.6,19.06 9.62,19.05 9.63,19.03 C9.65,19 9.68,18.96 9.71,18.94 L14.57,14.16 C14.81,13.92 15.21,13.92 15.45,14.16 C15.69,14.4 15.69,14.79 15.45,15.03 L11.66,18.76 L19.87,18.76 C20.04,18.76 20.2,18.83 20.31,18.94 C20.42,19.05 20.49,19.21 20.49,19.37 C20.49,19.71 20.21,19.98 19.87,19.98 Z M28.76,9.22 L1.26,9.22 L1.26,5.4 C1.26,4.79 1.76,4.3 2.38,4.3 L3.14,4.3 L3.14,5.81 C3.14,6.67 3.85,7.37 4.73,7.37 L5.93,7.37 C6.81,7.37 7.52,6.67 7.52,5.81 L7.52,4.3 L22.21,4.3 L22.21,5.81 C22.21,6.67 22.92,7.37 23.8,7.37 L25,7.37 C25.88,7.37 26.59,6.67 26.59,5.81 L26.59,4.3 L27.66,4.3 C28.28,4.3 28.78,4.79 28.78,5.4 L28.78,9.22 L28.76,9.22 Z"
                        id="d"
                      ></path>
                    </g>
                  </g>
                </svg>
              </div>
              <el-date-picker v-model="form.date" value-format="yyyy-MM-dd" type="daterange" :start-placeholder="ts('Check-in')['Check-in']" :end-placeholder="ts('Check-out')['Check-out']" align="center" :clearable="false"> </el-date-picker>
            </el-form-item>
            <el-form-item class="guest-room">
              <el-popover placement="bottom" width="230" trigger="click">
                <div class="choice">
                  <div class="child-kid">
                    <label>{{ ts('Number of guest')['Number of guest'] }}</label>
                    <div class="actions">
                      <el-input-number v-model="form.guestNumber" :min="1" step-strictly></el-input-number>
                    </div>
                  </div>
                  <div class="child-kid">
                    <label>{{ ts('Number of room')['Number of room'] }}</label>
                    <div class="actions">
                      <el-input-number v-model="form.roomNum" :min="1" step-strictly></el-input-number>
                    </div>
                  </div>
                </div>
                <div class="info" slot="reference">
                  <div class="icon-svg">
                    <svg width="26px" height="31px" viewBox="0 0 26 31" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g id="页面-1" stroke="none" stroke-width="1" fill-rule="evenodd">
                        <g id="icon-user" transform="translate(0.990000, -0.000000)">
                          <path
                            d="M12.32,0 C14.38,0 16.25,0.84 17.6,2.19 C18.95,3.54 19.79,5.41 19.79,7.47 C19.79,9.53 18.95,11.4 17.6,12.75 C16.99,13.36 16.27,13.87 15.47,14.24 C17.59,14.81 19.49,15.93 21.01,17.44 C23.24,19.67 24.63,22.75 24.63,26.13 L24.63,27.61 C24.63,28.36 24.33,29.04 23.83,29.53 C23.34,30.02 22.66,30.33 21.91,30.33 L2.72,30.33 C1.97,30.33 1.3,30.03 0.8,29.53 C0.31,29.04 0,28.36 0,27.61 L0,26.13 C0,22.74 1.38,19.67 3.62,17.44 C5.13,15.93 7.03,14.8 9.16,14.24 C8.37,13.87 7.65,13.36 7.03,12.75 C5.68,11.4 4.84,9.53 4.84,7.47 C4.84,5.41 5.68,3.54 7.03,2.19 C8.38,0.84 10.25,0 12.31,0"
                            id="d"
                          ></path>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <span style="color: #c0c4cc" v-if="showPlaceholder">{{ ts('Guest & Room')['Guest & Room'] }}</span>
                  <span v-else>{{ form.guestNumber }} {{ ts('Guest')['Guest'] }}, {{ form.roomNum }} {{ ts('Room')['Room'] }}</span>
                </div>
              </el-popover>
            </el-form-item>
          </div>
          <div class="btn-search" @click="submitForm('form')">
            <img src="../assets/images/icon-search.svg" width="45" />
            <span>{{ ts('Search')['Search'] }}</span>
          </div>
        </el-form>
      </div>
      <div class="search-result-title" v-if="isSearch">
        {{ ts('SEARCH RESULT')['SEARCH RESULT'] }}
        <p v-if="searchEmpty">{{ ts('Sorry, there is no matched property.Would you like to consider the following properties?')['Sorry, there is no matched property.Would you like to consider the following properties?'] }}</p>
      </div>
      <div class="hotel-list">
        <HotelItem :list="list" :date="form.date" />
      </div>
      <OtherSwiper />
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import { LanguagePackage } from '@/mixins/LanguagePackage'
import Carousel from '@/components/Carousel.vue'
import HotelItem from '@/components/HotelItem.vue'
import OtherSwiper from '@/components/OtherSwiper.vue'
import CustomerService from '@/components/CustomerService.vue'

export default {
  name: 'Home',
  mixins: [LanguagePackage],
  components: {
    Carousel,
    HotelItem,
    OtherSwiper,
    CustomerService,
  },
  data() {
    return {
      form: {
        destination: '',
        guestNumber: null,
        roomNum: null,
        date: '',
        pageSize: 999,
      },
      pageNo: 1,
      pageSize: 999,
      banner: [],
      list: [],
      isSearch: false,
      searchEmpty: false,
    }
  },
  created() {
    this.getData()
    this.getList()
  },
  computed: {
    showPlaceholder() {
      // 默认展示 Guest & Room
      const { guestNumber, roomNum } = this.form
      if (guestNumber > 1 || roomNum > 1) {
        return false
      }
      return true
    },
  },
  methods: {
    getData() {
      // 头部Banner
      getAction(`/pc/home/qryCarousel`, {
        // userId: this.userId,
        // typeId: '',
        pickUp: true,
      }).then((res) => {
        this.banner = res.result
      })
    },
    getList() {
      // 列表
      let { date, ...param } = this.form
      if (date.length > 0) {
        param.checkInDate = date[0]
        param.checkOutDate = date[1]
      } else {
        param.checkInDate = ''
        param.checkOutDate = ''
      }
      getAction(`/pc/home/qryHouseResourcesByPC`, param)
        .then((res) => {
          if (res.result.length > 0) {
            this.searchEmpty = false
            this.list = res.result
          } else {
            this.searchEmpty = true
            this.getEmptyList()
          }
        })
        .catch((err) => {
          this.searchEmpty = true
          this.getEmptyList()
        })
    },
    // 获取所有房源
    getEmptyList() {
      getAction(`/pc/home/qryHouseResourcesByPC`).then((res) => {
        this.list = res.result
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isSearch = true
          this.getList()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>
